import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_SURTIDOS_ACUMULADOS = process.env.REACT_APP_URL_SURTIDOS_ACUMULADOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedIsActive, setSelectedIsActive] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  // const [zonas, setZonas] = useState([]);
  // const [selectedZona, setSelectedZona] = useState("");
  const [impuestosFiltro, setImpuestosFiltro] = useState("");
  const [formaPagoFiltro, setFormaPagoFiltro] = useState("");
  const [cobradoresFiltro, setCobradoresFiltro] = useState([]);
  const [cobradorFiltro, setCobradorFiltro] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [facturaEdit, setFacturaEdit] = useState("");
  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [ordenCompraEdit, setOrdenCompraEdit] = useState("");
  const [cobradorEdit, setCobradorEdit] = useState("");
  const [empresaEdit, setEmpresaEdit] = useState("");
  const [modalEditNota, setModalEditNota] = useState(false);
  const toggleEditNota = () => setModalEditNota(!modalEditNota);

  const [saldo, setSaldo] = useState("");

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
  let allSurtidos = response.data;

  // ===== ARRAY DE COBRADORES (SIN DUPLICADOS) =====
  const cobradores = [
    ...new Set(
      allSurtidos
        .map((a) => a.cobrador)
        .filter((c) => c && c !== "NA" && c !== "")
    ),
  ];

  console.log("Cobradores:", cobradores);

  // ===== TU LÓGICA ORIGINAL =====
  let arrayTabla = allSurtidos
    .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
    .map((a) => {
      const fecha = new Date(a.fecha);
      const fechaPedido = new Date(a.pedidos[0].fecha);

      const diasDiferencia = Math.floor(
        (fecha - fechaPedido) / (1000 * 60 * 60 * 24)
      );

      return {
        _id: a._id,
        is_active: a.is_active,
        fecha: a.fecha,
        formaPago: a.formaPago,
        cobrador: a.cobrador,
        fechaPedido: a.pedidos[0].fecha,
        user: a.user[0].nombre + " " + a.user[0].apellido,
        idUser: a.user[0]._id,
        pedidos: a.pedidos[0].idPedido,
        idPedido: a.pedidos[0]._id,
        clientes: a.clientes[0].nombre_comercial,
        codigoClientes: a.clientes[0].codigo,
        idClientes: a.clientes[0]._id,
        idColaboradores: a.pedidos[0].colaboradores[0]._id,
        observaciones: a.observaciones,
        ordenCompra: a.ordenCompra,
        numero: a.idSurtido,
        impuestos: a.impuestos.toString(),
        subTotal: a.subTotal,
        iva: a.iva,
        total_general: a.total_general,
        RFC: a.clientes[0].RFC,
        vendedor:
          a.pedidos[0].colaboradores[0].nombre +
          " " +
          a.pedidos[0].colaboradores[0].apellido,
        plazo: a.clientes[0].plazo,
        saldo: a.saldo,
        comisionPagada: a.comisionPagada,
        empresa: a.empresa,
        factura: a.factura,
        devuelto: a.devuelto,
        diasDiferencia: diasDiferencia,
      };
    })
    .filter((el) => el != null);

  let dataFinal = Object.values(arrayTabla);

  setSurtidos(allSurtidos);
  setComments(dataFinal);

  // 👉 si quieres guardarlo en estado:
  setCobradoresFiltro(cobradores);
})

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
      // axios
      // .get(URL_GRUPOS, {
      //   headers: {
      //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //   },
      // })
      // .then((response) => {
      //   let allZonas = response.data;
      //   setZonas(allZonas);
      // })
      // .catch((err) => {
      //   console.log(err);
      // });
  }, [selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    let totalImportePDF = 0;
    let subTotalPDF = 0;
    let totalIVAPDF = 0;
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&&
        (selectedIsActive == 0 || selectedIsActive == a.is_active)&&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)&&
        (impuestosFiltro == 0 || impuestosFiltro == a.impuestos) &&
        (formaPagoFiltro == 0 || formaPagoFiltro == a.formaPago) &&
        (cobradorFiltro == 0 || cobradorFiltro == a.cobrador)
      ) {
        totalImportePDF = totalImportePDF + a.total_general;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.numero,
          a.fecha,
          a.fechaPedido,
          a.diasDiferencia,
          a.clientes,
          a.pedidos,
          a.formaPago,
          a.cobrador,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.subTotal),
          a.impuestos,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total_general),
          // a.user,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Fecha Pedido",
          "Dias",
          "Cliente",
          "Pedido",
          "Forma de Pago",
          "Cobrador",
          "SubTotal",
          "Impuestos",
          "IVA",
          "Total",
          // "Surtio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalPDF),
          "",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalImportePDF),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`Notas.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&&
        (selectedIsActive == 0 || selectedIsActive == a.is_active)&&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)&&
        (impuestosFiltro == 0 || impuestosFiltro == a.impuestos) &&
        (formaPagoFiltro == 0 || formaPagoFiltro == a.formaPago) &&
        (cobradorFiltro == 0 || cobradorFiltro == a.cobrador)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          FechaPedido: a.fechaPedido,
          Dias: a.diasDiferencia,
          Cliente: a.clientes,
          Pedido: a.pedidos,
          FormaPago: a.formaPago,
          Cobrador: a.cobrador,
          SubTotal: a.subTotal,
          Impuestos: a.impuestos,
          IVA: a.iva,
          Total: a.total_general,
          Surtio: a.user,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: ["Numero", "Fecha", "Fecha Pedido", "Cliente", "Pedido", "FormaPago", "Cobrador", "SubTotal", "Impuestos", "IVA", "Total", "Surtio"],
        sheetHeader: ["Numero", "Fecha", "Fecha Pedido", "Cliente", "Pedido", "FormaPago", "Cobrador", "SubTotal", "Impuestos", "IVA", "Total", "Surtio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&&
        (selectedIsActive == 0 || selectedIsActive == a.is_active)&&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)&&
        (impuestosFiltro == 0 || impuestosFiltro == a.impuestos) &&
        (formaPagoFiltro == 0 || formaPagoFiltro == a.formaPago) &&
        (cobradorFiltro == 0 || cobradorFiltro == a.cobrador)
      ) {
        return [a.numero, a.fecha, a.fechaPedido, a.diasDiferencia, a.clientes, a.pedidos, a.formaPago, a.cobrador, a.subTotal, a.impuestos, a.iva, a.total_general, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Fecha Pedido", "Dias", "Cliente", "Pedido", "Forma de Pago", "Cobrador", "SubTotal", "Impuestos", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function EditNota(id, clientes, numero, empresa, factura, observaciones, ordenCompra, cobrador) {

    setIdEdit(id);
    setClienteEdit(clientes);
    setNumeroEdit(numero);
    setEmpresaEdit(empresa);
    setFacturaEdit(factura);
    setObservacionesEdit(observaciones);
    setOrdenCompraEdit(ordenCompra);
    setCobradorEdit(cobrador);

    toggleEditNota();
  }

  function saveEditarNota(){
    axios.patch(
      `${URL_SURTIDOS}/${idEdit}`,
      {
        empresa: empresaEdit,
        factura: facturaEdit,
        observaciones: observacionesEdit,
        ordenCompra: ordenCompraEdit,
        cobrador: cobradorEdit
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Editar Nota",
          detalle: `${numeroEdit} ${clienteEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // axios.patch(
      //   URL_SIGNUP_DON,
      //   {
      //     nombre: nombre,
      //     apellido: apellido,
      //     email: email,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //     },
      //   }
      // );
      toggleEditNota();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    })


    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    });



  }

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {

        axios.post(
          URL_LOGS,
          {
            tipo: "Cancelar Nota",
            detalle: `${idNota}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    }
  });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    impuestos,
    formaPago,
    subTotal,
    iva,
    total_general,
    plazo,
    ordenCompra
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a._id,
              articulos: a.inventarios[0].articulos[0].nombre + " " + a.inventarios[0].articulos[0].codigo,
              unidad: a.inventarios[0].articulos[0].unidad,
              colores: a.inventarios[0].colores[0].name,
              cantidad: a.inventarios[0].cantidad,
              idArticulo: a.inventarios[0].articulos[0]._id,
              idColor: a.inventarios[0].colores[0]._id,
              precio: a.precio,
              total: parseFloat(a.precio) * parseFloat(a.inventarios[0].cantidad) ,
              tono: a.inventarios[0].tono,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        let cantidadRollos = dataFinal.length;

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"] + item["idColor"] + item["tono"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            idColor: item.idColor,
            tono: item.tono,
            cantidad: 0,
            rollos: 0,
            total: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].total += item.total;
          groups[val].articulos = item.articulos;
          groups[val].idArticulo = item.idArticulo;
          groups[val].idColor = item.idColor;
          groups[val].unidad = item.unidad;
          groups[val].colores = item.colores;
          groups[val].precio = item.precio;
          groups[val].tono = item.tono;
          groups[val].rollos += 1;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        let mts = agrupadoValues.filter((e) => e.unidad == "Metros");
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetrosEdit(TM);
        let KG = agrupadoValues.filter((e) => e.unidad == "Kilos");
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilosEdit(TK);

        const data = agrupadoValues.map((a) => {
          return [
            a.articulos,
            a.colores,
            a.tono,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.precio),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF();
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 150, 10, 35, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 80, 10, 30, 12);
        doc.setFontSize(10);
        doc.text(`Cliente ${clientes}`, 15, 25);
        doc.text(`Plazo ${plazo} días`, 15, 30);
        doc.text(
          `Metros ${new Intl.NumberFormat("en-US").format(TM)}`,
          15,
         35
        );
        doc.text(`Forma de Pago ${formaPago}`, 15, 40);
        doc.text(`Fecha ${fecha}`, 110, 25);
        doc.text(`Nota # ${numero}`, 110, 30);
        doc.text(`Pedido # ${pedidos}`, 110, 35);
        doc.text(`Orden de Compra: ${ordenCompra || "NA"}`, 110, 40);
        doc.text(`Forma de pago: Pago en una sola exhibición`, 15, 45);
        doc.text(`Método de pago y cuenta: PPD`, 15, 50);

        doc.autoTable({
          head: [
            [
              "Articulo",
              "Color",
              "Tono",
              "Cantidad",
              "Precio",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: 55,
          foot: [["", "", "", "", "Sub Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(subTotal)],
          ["", "", "", "", "IVA", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(iva)],
          ["", "", "", "", "Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(total_general)]],
          showFoot: "lastPage",
        });

        doc.setFontSize(10);
        var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        doc.save(`Nota-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  

  async function Utilidad(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    impuestos,
    subTotal,
    iva,
    total_general,
    plazo
  ) {
    let totalCosto = 0;
    let totalVenta = 0;
    let totalUtilidad = 0;
    await axios
      .get(`${URL_INVENTARIOS}/surtidos/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              idArticulo: a.articulos[0]._id,
              colores: a.colores[0].name,
              idColores: a.colores[0]._id,
              cantidad: a.cantidad,
              precio: parseFloat(a.articulosPedido[0].precio) * a.cantidad,
              costo: parseFloat(a.articulosOC[0].precio) * a.cantidad,
              utilidad: (parseFloat(a.articulosPedido[0].precio) - parseFloat(a.articulosOC[0].precio) * a.cantidad) ,
              tono: a.tono,
            };
          })
          .filter(function (el) {
            return el != null;
          });

          let agrupado = arrayTabla.reduce(function (groups, item) {
            const val = item["idArticulo"] + item["idColores"] + item["tono"]
        groups[val] = groups[val] || {
          idArticulo: item.idArticulo,
          idColores: item.idColores,
          tono: item.tono,
          costo: 0,
          precio: 0,
          utilidad: 0,
          cantidad: 0
        };
        groups[val].costo += item.costo;
        groups[val].precio += item.precio;
        groups[val].utilidad += item.utilidad;
        groups[val].cantidad += item.cantidad;
        groups[val].articulos = item.articulos;
        groups[val].idArticulo = item.idArticulo;
        groups[val].colores = item.colores;
        groups[val].idColores = item.idColores;
        return groups;
      },[])
  
      // let computedComments= Object.values(agrupado)

        let dataFinal = Object.values(agrupado);

        let mts = dataFinal.filter((e) => e.unidad == "Metros");
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetrosEdit(TM);
        let KG = dataFinal.filter((e) => e.unidad == "Kilos");
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilosEdit(TK);

        const data = dataFinal.map((a) => {
          totalCosto = totalCosto + a.costo;
          totalVenta = totalVenta + a.precio;
          return [
            a.articulos,
            a.colores,
            a.tono,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.precio),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.costo),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.precio - a.costo),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF();
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 150, 10, 35, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 80, 10, 30, 12);
        doc.setFontSize(10);
        doc.text(`Cliente ${clientes}`, 15, 25);
        doc.text(`Plazo ${plazo} días`, 15, 30);
        doc.text(
          `Metros ${new Intl.NumberFormat("en-US").format(TM)}`,
          15,
         35
        );

        doc.text(`Fecha ${fecha}`, 110, 25);
        doc.text(`Nota # ${numero}`, 110, 30);
        doc.text(`Forma de pago: Pago en una sola exhibición`, 110, 35);
        doc.text(`Método de pago y cuenta: PPD`, 110, 40);
       
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Color",
              "Tono",
              "Cantidad",
              "Venta",
              "Costo",
              "Utilidad",
            ],
          ],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              "",
              "",
              "",
              "Totales",
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalVenta),
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalCosto),
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalVenta - totalCosto),
            ],
          ],
          showFoot: "lastPage",
        });

        doc.setFontSize(10);
        var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        doc.save(`Nota-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Fecha Pedido", field: "fechaPedido", sortable: true },
    { name: "Dias", field: "diasDiferencia", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    // { name: "Zona", field: "zona", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Forma Pago", field: "formaPago", sortable: true },
    { name: "Cobrador", field: "cobrador", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "Impuestos", field: "impuestos", sortable: false },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.cobrador.toLowerCase().includes(search.toLowerCase()) ||
          comment.subTotal.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          // comment.zona.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.diasDiferencia.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    if (selectedIsActive) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(selectedIsActive)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }
    // if (selectedZona) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idZona.includes(selectedZona)
    //   );
    // }
    if (impuestosFiltro) {
      computedComments = computedComments.filter((e) =>
        e.impuestos.includes(impuestosFiltro)
      );
    }
    if (formaPagoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.formaPago.includes(formaPagoFiltro)
      );
    }
       if (cobradorFiltro) {
      computedComments = computedComments.filter((e) =>
        e.cobrador.includes(cobradorFiltro)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.empresa.includes(selectedEmpresa)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (saldo == "Si") {
      computedComments = computedComments.filter(
        (e) => e.saldo >= 0
      );
    }
    if (saldo == "No") {
      computedComments = computedComments.filter(
        (e) => e.saldo == 0
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "diasDiferencia" &&
      sorting.field != "total_general" &&
      sorting.field != "subTotal" &&
      sorting.field != "iva"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "diasDiferencia" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "diasDiferencia" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedIsActive,
    selectedCliente,
    selectedColaborador,
    // selectedZona,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    formaPagoFiltro,
    cobradorFiltro,
    impuestosFiltro,
    saldo,
    selectedEmpresa
  ]);

  async function kasher(
    id,
    subTotal,
    idClientes
  ) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a convertir la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Convertir!",
    }).then((result) => {
      if (result.isConfirmed) {
        
        let iva = (subTotal * 16)/100

        axios
        .patch(
          `${URL_SURTIDOS}Kasher/${id}`,
          {
            iva: iva.toFixed(2),
            clientes: idClientes
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });

      }
    });
    }

  // Inverso de kasher: quita el IVA y ajusta saldos.
  // El back rechaza la operacion si la nota ya tiene abonos aplicados.
  async function quitaIva(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a quitar el IVA de la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Quitar IVA!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_SURTIDOS}QuitaIva/${id}`,
            {},
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            Swal.fire("Good job!", "IVA quitado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                error.response?.data?.message || "Something went wrong!",
            });
            console.log(error);
          });
      }
    });
  }


  let totalImporteTabla = 0;
  let subTotalTabla = 0;
  let totalIVATabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_admin ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                Impuestos
              </Label>
              <Input
                bsSize="sm"
                type="select"
                value={impuestosFiltro}
                onChange={(e) => {
                  setImpuestosFiltro(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                 <option value={0}>No</option>
                 <option value={16}>Si</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                Activas
              </Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedIsActive}
                onChange={(e) => {
                  setSelectedIsActive(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                 <option value="No">No</option>
                 <option value="Si">Si</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Saldo</Label>
            <Input
                bsSize="sm"
                type="select"
                value={saldo}
                onChange={(e) => {
                  setSaldo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Pendientes</option>
                <option value="No">Liquidadas</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>

              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEmpresa}
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
                >
                  <option value="">Selecciona</option>
                  <option value="Imp. Casandra">Imp. Casandra</option>
                  <option value="ATB Textil">ATB Textil</option>
                  <option value="Taref">Taref</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>

              {/* <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedZona}
                onChange={(e) => {
                  setSelectedZona(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {zonas
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
              </td> */}

              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {colaboradores
                  .sort((a, b) =>
                    a.nombre > b.nombre ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre} {a.apellido}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={formaPagoFiltro}
                onChange={(e) => {
                  setFormaPagoFiltro(e.target.value);
                  setCurrentPage(1);
                }}
                >
                  <option value="">Selecciona</option>
                  <option value="Credito">Credito</option>
                  <option value="Contado">Contado</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
  bsSize="sm"
  type="select"
  value={cobradorFiltro}
  onChange={(e) => {
    setCobradorFiltro(e.target.value);
    setCurrentPage(1);
  }}
>
  <option value="">Selecciona</option>
  {cobradoresFiltro.map((cobrador, index) => (
    <option key={index} value={cobrador}>
      {cobrador}
    </option>
  ))}
</Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c"}}>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.fechaPedido}</td>
                      <td>{a.diasDiferencia}</td>
                      <td>{a.empresa}</td>
                      <td>{a.clientes}</td>
                      {/* <td>{a.zona}</td> */}
                      <td>{a.vendedor}</td>
                      <td>{a.is_active == "Si" ? (
                        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.total_general)
                          ) : undefined}
                      </td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                      <td></td>
                    </tr>
                  );
                }else{
                  totalImporteTabla = totalImporteTabla + a.total_general;
                  subTotalTabla = subTotalTabla + a.subTotal;
                  totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.fechaPedido}</td>
                      <td>{a.diasDiferencia}</td>
                      <td>{a.empresa}</td>
                      <td>{a.clientes}</td>
                      {/* <td>{a.zona}</td> */}
                      <td>{a.vendedor}</td>
                      <td>{a.formaPago}</td>
                      <td>{a.cobrador}</td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.subTotal)}
                      </td>
                      <td>{a.impuestos}</td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.iva)}
                      </td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(a.total_general)}
                      </td>
                      <td>
                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.impuestos,
                                  a.formaPago,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.plazo,
                                  a.ordenCompra
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) =>
                          EditNota(
                            a._id,
                            a.clientes,
                            a.numero,
                            a.empresa,
                            a.factura,
                            a.observaciones,
                            a.ordenCompra,
                            a.cobrador
                          )
                        }
                      >
                        <i class="far fa-edit"></i>
                      </Button>

                            {user.cancelarNota && a.comisionPagada == "No" && a.saldo == a.total_general && a.devuelto == "No" ? (
                            // {user.cancelarNota && a.comisionPagada == "No" ? (
                              <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                            ): (
                              <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              disabled
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                            )}
                            
                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) =>
                                Utilidad(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.plazo
                                )
                              }
                            >
                            <i class="fas fa-chart-line"></i>
                            </Button>
                          </>
                          {a.impuestos == "0" && user.notaKasher ?(
                                <Button
                                size="sm"
                                className="btn"
                                color="info"
                                onClick={(e) =>
                                  kasher(
                                    a._id,
                                    a.subTotal,
                                    a.idClientes
                                  )
                                }
                              >
                              K
                              </Button>
                          ):undefined}
                          {a.impuestos == "16" && user.notaKasher ?(
                                <Button
                                size="sm"
                                className="btn"
                                color="warning"
                                onClick={(e) => quitaIva(a._id)}
                              >
                              T
                              </Button>
                          ):undefined}
                      </td>
                    </tr>
                  );
                }

              })}
              <tr>
                {/* <td></td> */}
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(subTotalTabla)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
      <Modal size="sm" isOpen={modalEditNota} toggle={toggleEditNota}>
        <ModalHeader toggle={toggleEditNota}>
          <h4>Editar Nota {numeroEdit} Cliente {clienteEdit} </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Factura
              </Label>
              <Input
                bsSize="sm"
                type="text"
                value={facturaEdit}
                onChange={(e) => {
                  setFacturaEdit(e.target.value);
                }}
              />
              </Col>

            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Empresa
              </Label>
              <Input
                bsSize="sm"
                type="select"
                value={empresaEdit}
                onChange={(e) => {
                  setEmpresaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Imp. Casandra">Imp. Casandra</option>
                <option value="ATB Textil">ATB Textil</option>
                <option value="Taref">Taref</option>
              </Input>
            </Col>
            
             
            </Row>
            <Row>
            <Col md={12}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                bsSize="sm"
                type="text"
                value={observacionesEdit}
                onChange={(e) => {
                  setObservacionesEdit(e.target.value);
                }}
              />
              </Col>
            </Row>

            <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Orden de Compra
              </Label>
              <Input
                bsSize="sm"
                type="text"
                value={ordenCompraEdit}
                onChange={(e) => {
                  setOrdenCompraEdit(e.target.value);
                }}
              />
              </Col>

              <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Cobrador
              </Label>
              <Input
                bsSize="sm"
                type="text"
                value={cobradorEdit}
                onChange={(e) => {
                  setCobradorEdit(e.target.value);
                }}
              />
              </Col>
            </Row>
            <br />
          <Button size="sm" color="success" onClick={e=>saveEditarNota()} tabindex="-1">
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoVentas;
